import { CountriesModel } from './../../shared/Blimb/MasterData/CountriesModel';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserRegistration } from '../models/user-registration.model';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { CountriesService } from 'src/app/shared/Blimb/MasterData/countries.service';
import { CityService } from 'src/app/shared/city.service';
import { CityModel } from 'src/app/shared/city.model';

@Component({
  selector: 'app-auth-signup-three',
  templateUrl: './auth-signup-three.component.html',
  styleUrls: ['./auth-signup-three.component.css']
})

/**
 * Auth Signup-three Component
 */
export class AuthSignupThreeComponent implements OnInit {

  year = new Date().getFullYear()
  constructor(private fb:FormBuilder,
    private authService:AuthService,
    public router :Router,
    private countryService:CountriesService,
    private cityService:CityService) { }
  form:FormGroup;
  countries:CountriesModel[]=[];
  cities:CityModel[]=[];
  model:UserRegistration={};
  createForm():FormGroup{
    return this.fb.group({
      id       :[this.model.id       ],
      userId   :[this.model.userId   ],
      firstName:[this.model.firstName,Validators.required],
      lastName :[this.model.lastName,Validators.required ],
      email    :[this.model.email,Validators.required    ],
      phone    :[this.model.phone ,Validators.required   ],
      password :[this.model.password,Validators.required ],
      imageUrl :[this.model.imageUrl ],
      adress   :[this.model.adress   ],
      countryId:[this.model.countryId],
      cityId   :[this.model.cityId   ],
      CountryCode   :[this.model.CountryCode],
    })
  }
  ngOnInit(): void {
    this.countryService.getAll()
    .subscribe(result => {
      this.countries = result;
      this.model = new UserRegistration();
      this.form=this.createForm();
    })
  }
  countryChanged(){
    debugger;
    var countryId=this.form.controls['countryId'].value;
    var index=this.countries.findIndex(x=>x.id == countryId);
    if(index>-1){
      this.form.controls['CountryCode'].setValue(this.countries[index].countryCode);
    }
    this.form.controls['cityId'].setValue(0);
    if(countryId > 0){
      this.cityService.getAllByCountryId(countryId)
      .subscribe(cities=>{
        this.cities = cities;
        console.log(' this.cities', this.cities)
      })
    }
  }
  submit(){
    this.model = this.form.getRawValue();
    console.log('model',this.model)
    this.model.phone = this.model.CountryCode + this.model.phone;
    this.model.IsLogin=true;
    this.authService.register(this.model)
    .subscribe(data=>{
      if (data === 'Phone Used' || data === 'Email Used') {
        // this.toaster.warning('You already have an account');
      }
      else{
        localStorage.setItem('token', data.token);
        localStorage.setItem('currentUser', JSON.stringify(data));
        this.router.navigate(['']);
        this.authService.loggedIn = true;
      }
   },
     error => {
        // this.toaster.error('This is not good!', 'You already have an account');
      }
    )
  }
  onUploadFinished($event){
    this.form.controls['imageUrl'].setValue($event)
  }
}
